import React, { useState } from 'react'
import * as Yup from 'yup'
import axios from 'axios'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'
import DosingModeConfigurationForm from './DosingModeConfigurationForm'

const DosingModeConfigurationPage = ({
  dosingModeConfiguration: initialDosingModeConfiguration
}) => {

  const [dosingModeConfiguration, setDosingModeConfiguration] = useState(initialDosingModeConfiguration)
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const handleSubmit = (submittedDosingModeConfig, onFinished) => {
    const { emergency_feeder_dosing_mode_parameters, ...dosingModeConfiguration } = submittedDosingModeConfig
    const body = {
      dosing_mode_configuration: {
        ...dosingModeConfiguration,
        emergency_feeder_dosing_mode_parameters_attributes: emergency_feeder_dosing_mode_parameters
      },
    }

    axios.put(`/admin/dosing_mode_configurations/${dosingModeConfiguration.id}`, body)
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'dosing_mode_configurations' }))
        onFinished(true, null)
        setDosingModeConfiguration(resp.data)
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'dosing_mode_configurations' }))
        onFinished(false, error.response.data)
      })
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={['Edit', t('dosing_mode_configurations.dosing_mode_configuration')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <DosingModeConfigurationForm
              dosingModeConfiguration={dosingModeConfiguration}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default DosingModeConfigurationPage
